module.exports = __webpack_public_path__ + "6baebd0ffe9dec1adff17444c9be49bf.png";